export function colToLetter(index: number): string {
    let value = ''
    let col = index
    while (col >= 0) {
        value = String.fromCharCode(65 + (col % 26)) + value
        col = Math.floor(col / 26) - 1
    }
    return value
}
